import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { BottomSheet } from "components/BottomSheet";
import { SheetPrimaryButton, SheetSecondaryButton } from "./SheetActions";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  paragraphs?: string[];
  actionText?: string;
  actionHandler: () => void;
  isLoading?: boolean;
  loadingText?: string;
};

export const OperatorDangerSheet = ({
  isOpen,
  onClose,
  title = "Ta bort",
  paragraphs = ["Detta går inte att ångra"],
  actionHandler,
  actionText = "Ta bort",
  isLoading = false,
  loadingText = "Tar bort...",
}: Props) => (
  <BottomSheet isOpen={isOpen} onClose={onClose} title={title}>
    <div className="flex items-start gap-x-3 pb-2">
      <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-red-50">
        <ExclamationTriangleIcon
          className="h-6 w-6 text-red-600"
          aria-hidden="true"
        />
      </div>
      <div className="space-y-1 pt-2">
        {paragraphs.map((message) => (
          <p key={message} className="text-sm text-gray-600">
            {message}
          </p>
        ))}
      </div>
    </div>
    <div className="mt-4 flex gap-x-3 border-t border-gray-75 pt-4">
      <SheetSecondaryButton onClick={onClose} />
      <SheetPrimaryButton
        type="button"
        variant="danger"
        onClick={actionHandler}
        isLoading={isLoading}
        loadingText={loadingText}
      >
        {actionText}
      </SheetPrimaryButton>
    </div>
  </BottomSheet>
);
